import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'pl'],
    debug: false, // Reduce console noise in production
    
    // Force reload of resources
    load: 'languageOnly',
    
    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      allowMultiLoading: false,
    },

    // Default namespace
    defaultNS: 'common',
    ns: ['common'],
    
    // Add these to improve initialization
    preload: ['en', 'pl'],
    keySeparator: '.',
    nsSeparator: ':',
    returnEmptyString: false,
    returnNull: false,
    returnObjects: false,
    
    // Wait for resources to load
    initImmediate: false,
  });

export default i18n;